module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMwIiBoZWlnaHQ9IjQ1NSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTI1NS4yMTQ5MzUgNzkuMTgxMTVsLTM5LjczNzI5NiA2OC45ODY4MzItMzkuNzM3Mjk2LTY4Ljk4NjgzMkg0My40MDk0ODRsMTcyLjA2ODE1NSAyOTguNzE5OCAxNzIuMDY4MTU1LTI5OC43MTk4eiIgZmlsbD0iIzREQkE4NyIvPgogICAgPHBhdGggZD0iTTI1NS4yMTQ5MzUgNzkuMTgxMTVsLTM5LjczNzI5NiA2OC45ODY4MzItMzkuNzM3Mjk2LTY4Ljk4NjgzMmgtNjMuNTAzNTk3bDEwMy4yNDA4OTMgMTc5LjIzMTUyOUwzMTguNzE4NTMyIDc5LjE4MTE1eiIgZmlsbD0iIzQzNTQ2NiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/vuejs.svg
// module id = C7b/
// module chunks = 0